export function SurveySvg({ fillColor = "#FFFFFF", size = 50 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.872 42.4805H5.12804C3.91364 42.4805 2.92004 43.3085 2.92004 44.3205C2.92004 45.3325 3.91364 46.1605 5.12804 46.1605H44.872C46.0864 46.1605 47.08 45.3325 47.08 44.3205C47.08 43.3085 46.0864 42.4805 44.872 42.4805Z"
        fill={fillColor}
      />
      <path
        d="M10.648 38.7997H8.62398C7.51078 38.7997 6.59998 37.8061 6.59998 36.5917V7.88769C6.59998 6.67329 7.51078 5.67969 8.62398 5.67969H10.648C11.7612 5.67969 12.672 6.67329 12.672 7.88769V36.5917C12.672 37.8061 11.7612 38.7997 10.648 38.7997Z"
        fill={fillColor}
      />
      <path
        d="M21.3201 38.7997H19.2961C18.1829 38.7997 17.2721 37.8062 17.2721 36.5918V25.5517C17.2721 24.3373 18.1829 23.3438 19.2961 23.3438H21.3201C22.4333 23.3438 23.3441 24.3373 23.3441 25.5517V36.5918C23.3441 37.8062 22.4333 38.7997 21.3201 38.7997Z"
        fill={fillColor}
      />
      <path
        d="M31.9922 38.7987H29.9682C28.855 38.7987 27.9442 37.8051 27.9442 36.5907V14.5107C27.9442 13.2963 28.855 12.3027 29.9682 12.3027H31.9922C33.1054 12.3027 34.0162 13.2963 34.0162 14.5107V36.5907C34.0162 37.8051 33.1054 38.7987 31.9922 38.7987Z"
        fill={fillColor}
      />
      <path
        d="M42.6642 38.7978H40.6402C39.527 38.7978 38.6162 37.8042 38.6162 36.5898V21.1338C38.6162 19.9194 39.527 18.9258 40.6402 18.9258H42.6642C43.7774 18.9258 44.6882 19.9194 44.6882 21.1338V36.5898C44.6882 37.8042 43.7774 38.7978 42.6642 38.7978Z"
        fill={fillColor}
      />
    </svg>
  );
}
